import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import CustomField from '../../Fields/CustomField.jsx';


const validate = values => {
  const errors = {};

  if (values && !values.code) {
    errors.code = 'required';
  }

  return errors;
};

@reduxForm({ form: 'InsertInvitationCodeForm', validate })
class InsertInvitationCodeForm extends React.Component {
  render() {
    return (
      <div style={{ margin: 15 }}>
        <Entity
          name="code"
          componentClass={Field}
          componentAttribute="placeholder"
          entity="invitationCode"
          titleColor="#3f3f3f"
          component={CustomField}
        />
      </div>
    );
  }
} 

export default InsertInvitationCodeForm;
